
let facebookPromise = null

export function initFacebookSdk(appId, appVersion, locale) {
    if (facebookPromise) {
        return facebookPromise
    }

    return facebookPromise = new Promise(resolve => {
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: appId,
                cookie: true,
                xfbml: false,
                version: appVersion
            });
            resolve();
        };

        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/" + locale + "/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    });
}